import { io } from 'socket.io-client';

const socket = io(('https://large-bkd.onrender.com'), {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 3
});

export default socket;
